"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBorderRadiusMobile = exports.getBorderRadius = exports.getBorder = void 0;

var getBorder = function getBorder(_ref) {
  var theme = _ref.theme;
  return "".concat(theme.orbit.borderWidthCard, " ").concat(theme.orbit.borderStyleCard, " ").concat(theme.orbit.borderColorCard);
};

exports.getBorder = getBorder;

var getBorderRadius = function getBorderRadius(_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.orbit.borderRadiusNormal);
};

exports.getBorderRadius = getBorderRadius;

var getBorderRadiusMobile = function getBorderRadiusMobile(_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.orbit.borderRadiusLarge);
};

exports.getBorderRadiusMobile = getBorderRadiusMobile;